module.exports = __webpack_public_path__ + "static/media/office-960.3898a00c.webp";